import { PreCallInfo } from '@nimbus-assistant/enums/pre-call-info';

export class NimbusUserSettings {
  public openLoginWindowOnStartup?: boolean;
  public language: string;
  public position: string;
  public autorun: boolean;
  public onTopTeamToast: boolean;
  public preCallInfo?: PreCallInfo;
  public zoom?: number;
  public settingsWidth?: number;
  public settingsHeight?: number;
  public useAudioForExternalTasks?: boolean;
  public audioForExternalTasks?: string;
  public useAudioForInstantMessages?: boolean;
  public audioForInstantMessages?: string;
  public useAudioForEmails?: boolean;
  public audioForEmails?: string;
  public bringToForeground?: boolean;
  public topmost?: boolean;
  public signalRLoggingEnabled?: boolean;

  public windowWidth?: number;
  public windowHeight?: number;
  public windowMarginVertical?: number;
  public windowMarginRight?: number;

  public constructor({
    autorun,
    language,
    position,
    openLoginWindowOnStartup,
    onTopTeamToast,
    preCallInfo,
    zoom,
    bringToForeground,
  }: NimbusUserSettings) {
    this.autorun = autorun;
    this.language = language;
    this.position = position;
    this.openLoginWindowOnStartup = openLoginWindowOnStartup;
    this.onTopTeamToast = onTopTeamToast;
    this.preCallInfo = preCallInfo;
    this.zoom = zoom;
    this.bringToForeground = bringToForeground;
  }
}
